import {
  useCompanyHasFunctionality,
  useCompanyId,
} from "src/Pages/Company/CompanyContext";
import useFetchListOfStructures from "src/Pages/Company/OrganizationStructure/api/useFetchListOfStructures";
import { organizationStructureModuleRead } from "src/utils/RoleBasedSecurity/permissions";
import useHasPermission from "src/utils/hooks/security/useHasPermission";

export const useHasStructure = () => {
  const companyId = useCompanyId();
  const companyFunctionalitySO = useCompanyHasFunctionality(
    "ENABLE_ORGANIZATION_STRUCTURE"
  );
  const hasModuleAccessSO: boolean | null = useHasPermission(
    organizationStructureModuleRead
  );

  const shouldFetch: boolean =
    companyFunctionalitySO && hasModuleAccessSO !== null && hasModuleAccessSO;

  const { data: structureData, isLoading } = useFetchListOfStructures(
    companyId,
    shouldFetch
  );

  const hasStructure = Boolean(structureData?.[0]?.structureId);

  return { hasStructure, isLoading };
};
